$(document).on('click', '.tabs-nav li:not(.active)', function(e){
    e.preventDefault();
    $(this).siblings('li').removeClass('active');
    $(this).addClass('active');
    let tab = $(this).attr('data-tab');
    let tab_content = $('.tab-content[data-tab="'+ tab +'"]');
    tab_content.siblings().removeClass('active');
    tab_content.addClass('active').hide().fadeIn();
    if(typeof $(this).data('scroll') !== 'undefined'){
        scrollTo(tab_content);
    }
})

$('.js-open-tab').click(function(){
    let tab = $(this).attr('data-tab');
    $('.tabs-nav li[data-tab="'+ tab +'"]').click();
    scrollTo($('.tab-content[data-tab="'+ tab +'"]'));
})
